import { AnyAction, createSlice } from '@reduxjs/toolkit';
import { revertAll } from './userReducer';

export interface Notification {
    userName: string;
    notificationMessage: string;
    isRead: boolean;
    createdAt: number;
    notificationTitle:string
}

const initialState: Notification[] = [];

const notificaitionReducer = createSlice({
    name: 'notification',
    initialState: initialState,
    reducers: {
        setNotification: (state, action: AnyAction) => {

            return action.payload;
        },
        updateNotification: (state, action) => {

            const indexOfNotificationToChange = state.findIndex(notification => notification.userName === action.payload.userName);
            const changedNotification = action.payload;

            state[indexOfNotificationToChange] = changedNotification;
            return state;
        },
    },
    extraReducers(builder) {
        builder
            .addCase(revertAll, () => initialState);
    }
});

export const { setNotification, updateNotification } = notificaitionReducer.actions;

export default notificaitionReducer;